import React, { useState } from "react";
import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import { StoreModel } from "../../../../../../redux/reducers/static-data.reducers";
import { DialogContent, Grid } from "@mui/material";
import {
  Message,
  MessageSections,
} from "../../../../../../pages/components/message/message";
import { StandardDialogFooter } from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import productStoresService from "../../../../../../services/product-stores.service";
import { AxiosError } from "axios";
import { mapValidationErrors } from "../../../../../../pages/user/settings/personal-info/personal-info.service";
import { BarekamSelect } from "../../../../../../pages/components/select/select";
import BarekamText from "../../../../../../pages/components/text";
import { BarekamMenuItem } from "../../../../../../pages/components/select/styled/orders";
import { STATUSES } from "../../../../../../constants";

const EditStore = ({
  storeData,
  onCancel,
}: {
  storeData: StoreModel;
  onCancel: () => void;
}) => {
  const [modifiedStoreData, setModifiedStoreData] = useState(storeData);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  function handleChange(field: "name" | "status", value: any) {
    setModifiedStoreData((prevState) => {
      prevState[field] = value;
      return { ...prevState };
    });
  }

  function validateData() {
    const errors = {} as { [key: string]: string };

    if (
      !modifiedStoreData.name ||
      Object.keys(modifiedStoreData.name).length < 1
    ) {
      errors["name"] = "required";
    }
    return errors;
  }

  function handleSave() {
    const errors = validateData();
    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (modifiedStoreData.storeId) {
        productStoresService
          .editProductStore(modifiedStoreData.storeId, modifiedStoreData)
          .then(() => onCancel())
          .catch((reason) => {
            if (reason instanceof AxiosError) {
              setErrors(mapValidationErrors(reason));
            }
          });
      } else {
        // TODO: new store
      }
    }
  }

  return (
    <>
      <DialogContent>
        <Grid container rowSpacing={"1rem"} columnSpacing={"1rem"}>
          <BarekamInputMultilingual
            multilingualText={storeData.name || {}}
            labelKey={"name"}
            field={"name"}
            onChange={(name) => handleChange("name", name)}
            errors={errors}
          />

          <Grid item xs={12}>
            <BarekamSelect
              variant={"outlined"}
              placeholder={modifiedStoreData?.status || ""}
              label={
                <BarekamText variant={"1rem"}>
                  <Message
                    messageKey={"store_status"}
                    sectionId={MessageSections.ORDERS}
                  />
                </BarekamText>
              }
              value={modifiedStoreData?.status?.toLowerCase() || ""}
              type={"standard"}
              error={!!errors["store_status"]}
              fullWidth
              required
            >
              {STATUSES.map((status) => {
                return (
                  <BarekamMenuItem
                    key={status}
                    value={status.toLowerCase()}
                    onClick={() => handleChange("status", status.toLowerCase())}
                  >
                    {status}
                  </BarekamMenuItem>
                );
              })}
            </BarekamSelect>
          </Grid>
        </Grid>
      </DialogContent>

      <StandardDialogFooter
        onCancel={() => onCancel()}
        onSave={() => handleSave()}
        saveLabel={
          <Message messageKey={"save"} sectionId={MessageSections.MAIN} />
        }
      />
    </>
  );
};

export default EditStore;
